import React from 'react';

interface IconButtonProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  color?: 'default' | 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
  edge?: 'start' | 'end' | false;
  className?: string;
  children?: React.ReactNode;
  sx?: React.CSSProperties;
}

const IconButton: React.FC<IconButtonProps> = ({
  onClick,
  disabled = false,
  size = 'medium',
  color = 'default',
  edge,
  className = '',
  children,
  sx,
}) => {
  const baseClasses = 'inline-flex items-center justify-center rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';
  
  const sizeClasses = {
    small: 'p-1',
    medium: 'p-2',
    large: 'p-3',
  };

  const colorClasses = {
    default: 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800',
    primary: 'text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20',
    secondary: 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800',
    error: 'text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20',
    warning: 'text-yellow-600 dark:text-yellow-400 hover:bg-yellow-50',
    info: 'text-blue-500 dark:text-blue-400 hover:bg-blue-50',
    success: 'text-green-600 dark:text-green-400 hover:bg-green-50',
  };

  const classes = `${baseClasses} ${sizeClasses[size]} ${colorClasses[color]} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={classes}
      style={sx}
    >
      {children}
    </button>
  );
};

export default IconButton;

